import { Box, ProgressBar, Card } from '@nimbus-ds/components';
import useNuvemEnvioTranslations from 'domains/NuvemEnvioCommons/hooks/useNuvemEnvioTranslations/useNuvemEnvioTranslations';
import LabelProgressTitle from './components/LabelProgressTitle';

interface ProgressCardProps {
  progressPercentage: number;
}

function ProgressCard({ progressPercentage }: Readonly<ProgressCardProps>) {
  const t = useNuvemEnvioTranslations();

  return (
    <Box id="ProgressCard">
      <Card>
        <Card.Header>
          <LabelProgressTitle
            title={t(
              'printNuvemEnvioLabelsStatus.asyncPage.progressCard.title',
            )}
          />
        </Card.Header>
        <Card.Body>
          <ProgressBar appearance="primary" value={progressPercentage} />
        </Card.Body>
      </Card>
    </Box>
  );
}

export default ProgressCard;
